import api from "./api";

const listarDiretorios = async () => {
    try {
        const response = await api.get("/diretorios");
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const listarDiretoriosPorIDPai = async (IDDiretorioPai, IDProcesso, filtros = {}) => {
    try {
        const response = await api.get(`/diretorioByIDPai/${IDDiretorioPai}/${IDProcesso}`, {
            params: filtros,
        });
        return response.data;
    } catch (error) {
        console.log(error);
    }
};

const atualizarSituacaoDiretorio = async (IDDiretorio, situacao) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/situacao`, { situacao });
        return response;
    } catch (error) {
        console.error('Falha ao atualizar situação do diretório', error);
        throw error;
    }
};

const renomearDiretorio = async (IDDiretorio, nome) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/renomear`, { descricaoExibicao: nome });
        return response;
    } catch (error) {
        console.error('Falha ao renomear o diretório', error);
        throw error;
    }
};

const buscarProtecaoDiretorio = async (IDDiretorio) => {
    try {
        const response = await api.get(`/diretorio/${IDDiretorio}/protecao`);
        return response.data;
    } catch (error) {
        console.error('Falha ao buscar protecao do diretorio', error);
        throw error;
    }
};

const buscarConteudoAvancado = async (IDProcesso, IDDiretorioRaiz, termo) => {
    const response = await api.get("/diretorios/busca-avancada", {
        params: { IDProcesso, IDDiretorioRaiz, termo },
    });
    return response.data;
};

const baixarDiretorioCompactado = async (IDDiretorio) => {
    return api.get(`/diretorio/${IDDiretorio}/download`, {
        responseType: "blob",
    });
};

const listarDestinosMovimento = async (IDDiretorioPai, IDProcesso) => {
    const response = await api.get(`/diretorioByIDPai/${IDDiretorioPai}/${IDProcesso}`);
    return Array.isArray(response.data?.diretorios) ? response.data.diretorios : [];
};

const moverDiretorio = async (IDDiretorio, IDDiretorioDestino) => {
    return api.put(`/diretorio/${IDDiretorio}/mover`, { IDDiretorioDestino });
};

const salvarProtecaoDiretorio = async (
    IDDiretorio,
    protegida,
    cargos,
    protegidaGrupo = 0,
    grupos = []
) => {
    try {
        const response = await api.put(`/diretorio/${IDDiretorio}/protecao`, {
            protegida,
            cargos,
            protegidaGrupo,
            grupos,
        });
        return response;
    } catch (error) {
        console.error('Falha ao salvar protecao do diretorio', error);
        throw error;
    }
};

export const diretorioService = {
    listarDiretorios,
    listarDiretoriosPorIDPai,
    atualizarSituacaoDiretorio,
    renomearDiretorio,
    buscarProtecaoDiretorio,
    buscarConteudoAvancado,
    baixarDiretorioCompactado,
    listarDestinosMovimento,
    moverDiretorio,
    salvarProtecaoDiretorio
};
